<template>
    <v-container>
        <template v-if="replied">
            <v-alert
                :type="error ? 'error' : 'success'"
                border="top"
            >
                {{message}}
            </v-alert>
        </template>
    </v-container>
</template>

<script>
import axios from "axios"

export default {
    name: 'activateacct',
    metaInfo: {
        title: 'Digital Tuguegarao - Account Activation',
    },
    data() {
        return {
            replied: false,
            message: '',
            error: false,
        }
    },
    methods: {
        redirect() {
            setTimeout(() => {
                this.$router.push({
                    name: 'login',
                }).catch(() => {})
            }, 5000)
        },
        activate(code) {
            axios({
                method: 'post',
                url: `${this.domain}/crm_user_activate_account_from_email`,
                data: {
                    code,
                }
            })
                .then(response => {
                    this.replied = true
                    this.error = !response.data.response
                    this.message = response.data.message

                    this.redirect()
                })
                .catch(() => {
                    this.replied = true
                    this.error = true
                    this.message = 'Something went wrong... Try again later...'

                    this.redirect()
                })
        }
    },
    mounted() {
        this.activate(this.$route.params.ctzncode)
    }
}
</script>